import { ChaveContratoEnum } from '../ChaveContratoEnum';
import { ContratoMenuModel } from './ContratoMenuModel';

export class NavigationMenuModel extends ContratoMenuModel {
    title: String
    icon: String
    tab: String
    selected: boolean = false
    countBadge: number = 0
    chaveContrato = []

    public static getNavigationMenu(): Array<NavigationMenuModel> {
        const menu = []
        let item = null

        // item = new NavigationMenuModel()
        // item.title = 'configurações'
        // item.icon = 'icon-config'
        // item.tab = 'configuracoes'
        // item.active = true
        // item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        // menu.push(item)

        item = new NavigationMenuModel()
        item.title = 'análise'
        item.icon = 'icon-solicita'
        item.tab = 'analise-ativos'
        item.active = true
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_ANALISE_ACOES,
            ChaveContratoEnum.CONTRATO_ANALISE_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_ANALISE_EUA,
            ChaveContratoEnum.CONTRATO_ANALISE_FUNDOS_IMOBILIARIOS,
            ChaveContratoEnum.CONTRATO_ANALISE_FUNDOS_INDICES,
            ChaveContratoEnum.CONTRATO_ANALISE_INDICES
        ]
        menu.push(item)

        item = new NavigationMenuModel()
        item.title = 'prisma'
        item.icon = 'icon-prisma'
        item.tab = 'prisma'
        item.active = true
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_PRISMA_ACOES,
            ChaveContratoEnum.CONTRATO_PRISMA_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_PRISMA_EUA,
            ChaveContratoEnum.CONTRATO_PRISMA_FUNDOS_IMOBILIARIOS,
            ChaveContratoEnum.CONTRATO_PRISMA_FUNDOS_INDICES,
            ChaveContratoEnum.CONTRATO_PRISMA_INDICES
        ]
        menu.push(item)

        item = new NavigationMenuModel()
        item.title = 'home'
        item.icon = 'icon-home'
        item.tab = 'home'
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)

        item = new NavigationMenuModel()
        item.title = 'recomendações'
        item.icon = 'icon-recomenda'
        item.tab = 'recomendacoes'
        item.active = true
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES,
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA
        ]
        menu.push(item)

        item = new NavigationMenuModel()
        item.title = 'carteiras'
        item.icon = 'icon-carteira-recomendada'
        item.tab = 'carteira-recomendada'
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        item.active = true
        menu.push(item)

        return menu;
    }
}